// eslint-disable-next-line import/no-extraneous-dependencies
import { FuroDataCheckboxInput } from '@furo/data-input/src/furo-data-checkbox-input';

export class FormFuroFatBool extends FuroDataCheckboxInput {}

window.customElements.define('form-furo-fat-bool', FormFuroFatBool);
